import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface Props {
  children: ReactNode;
  twoRowsOnMobile?: boolean;
}

export default function ListActionsWrapper({
  children,
  twoRowsOnMobile,
}: Props) {
  return (
    <div
      className={twMerge(
        "flex justify-between mt-10 mb-10 items-center md:gap-0 md:flex-row max-w-7xl mx-auto",
        twoRowsOnMobile ? "flex-col gap-2" : "px-5 md:px-10 lg:px-0",
      )}
    >
      {children}
    </div>
  );
}
